import { useLocation } from "react-router-dom";
import track, {
  TRACKING_TYPES,
} from "../../../../../Utils/SupabaseServices/Track";
import { TRACKING_EMBED_TYPES } from "../../../../../Utils/SupabaseServices/TrackEmbed";
import trackEmbed from "../../../../../Utils/SupabaseServices/TrackEmbed";
import { getPublicUrl, getPublicUrlWithUsername } from "../../../../../Utils/CustomDomain/CustomDomainFuntions";



const SeeMoreTile= ({
  data,
  type,
  user_id,
  username,
  unique_id,
  component,
  total_count,
  from
}:any) => {
  const location = useLocation();

  const handleNavigate = (component: any) => {
    if(from=="embed-search"){

      trackEmbed("Carousel Click", TRACKING_EMBED_TYPES.EVENT, {
        pathname: location.pathname,
        details: {
          unique_id: component?.unique_id,
          type: component?.type,
          title: component?.name,
        },
        user_id: user_id,
        title: "Stay Up To Date",
      });
      trackEmbed(`/${username}`, TRACKING_EMBED_TYPES.PAGE, {
        pathname: `/${username}`,
        details: {
          unique_id: component?.unique_id,
          type: component?.type,
          title: component?.name,
        },
        user_id: user_id,
        title: "Stay Up To Date",
      });
    }else{
    track("Carousel Click", TRACKING_TYPES.EVENT, {
      pathname: location.pathname,
      details: {
        unique_id: component?.unique_id,
        type: component?.type,
        title: component?.name,
      },
      user_id: user_id,
      title: "Stay Up To Date",
    });
    track(`/${username}`, TRACKING_TYPES.PAGE, {
      pathname: `/${username}`,
      details: {
        unique_id: component?.unique_id,
        type: component?.type,
        title: component?.name,
      },
      user_id: user_id,
      title: "Stay Up To Date",
    });
  }
    // const url = `/${username}/${unique_id}`;
    const url = getPublicUrlWithUsername(username, unique_id);

    sessionStorage.setItem("componentData", JSON.stringify(component));

    window.open(url, "_blank", "noopener,noreferrer");
  };
  return (
    <>
      {data && total_count > 25 && (
        <div className="link-url">
          <div
            className="creator-feed-image-wrapper-links square-wrapper"
            style={{
              backgroundColor: "#e8e8e8",
              color: "#000",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              height:
                component?.content_shape === "sq" ||
                  data.slice(0, 25).every((item: any) => item.type === "FEED")
                  ? "143px"
                  : "250px",
              width: "143px",
              borderRadius: "8px",
            }}
            onClick={() => {
              handleNavigate(data);
            }}
          >
            <div style={{ fontSize: "16px", fontWeight: "bold" }}>View All</div>

            <div style={{ fontSize: "16px", marginBottom: "8px" }}>
              {total_count - 25} more items
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SeeMoreTile;
